import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import {
  HeroSection,
  PersonasSection,
  IntelligenceSection,
  PricingSection,
  FinalCtaSection,
} from '../modules/landing';

export const LandingPage: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          const headerOffset = 70;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }, 100);
      }
    }
  }, [location.hash]);

  return (
    <>
      <Header progress={0} />
      <Box component="main">
        <HeroSection />
        <PersonasSection />
        <IntelligenceSection />
        <PricingSection />
        <FinalCtaSection />
      </Box>
      <Footer />
    </>
  );
}; 